export default __webpack_public_path__ + "static/media/users.80f78c43.svg";